import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  user: null,
  response: null,
  loading: false,
  error: null,
  callTimes: 0,
  message: '',
  data: []
}

export const customerSlice = createSlice({
  name: 'customerSliceName',
  initialState,
  reducers: {
    addCustomer: (state) => {
      state.loading = true;
    },
    getCustomer: (state) => {
      state.loading = true;
    },
    getOneCustomer: (state) => {
      state.loading = true;
    },

    successCustomer: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    searchByMobile: (state) => {
      state.loading = true;
    },
    removeCustomer: (state) => {
      state.loading = true;
    },
    updateCustomer: (state) => {
      state.loading = true;
    },
  },
})

// Action creators are generated for each case reducer function
export const { addCustomer, removeCustomer, updateCustomer, getCustomer, successCustomer, getOneCustomer, searchByMobile } = customerSlice.actions

export default customerSlice.reducer